import { Client, TestUserInput } from './types';


export function emptyClient(): Client {
  return {
    id: '',
    clientId: '',
    enabled: true,
    name: '',
    description: '',

    publicClient: false,
    bearerOnly: false,
    serviceAccountEnabled: false,

    standardFlowEnabled: true,
    enforcePkce: true,
    implicitFlowEnabled: false,
    directAccessGrantsEnabled: false,

    fullScopeAllowed: false,

    rootUrl: '',
    baseUrl: '',

    webOrigins: [],
    redirectUris: [],

    associatedRole: '',
  };
}

export function emptyTestUser(): TestUserInput {
  return {
    username: '',
    email: '',
    firstName: '',
    lastName: '',

    enabled: true,
    emailVerified: false,
    note: '',

    owners: [],
    attributes: {},
    associatedClients: [],
    addToSickEmployeeGroup: true,
  };
}
